var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-activity-table-process-cell-container",class:("cell-of-process-" + _vm.solanProcess),style:(_vm.styles)},[_c('div',{staticClass:"cell-content"},[_vm._v(_vm._s(_vm._solanProcessTextOf(_vm.solanProcess)))])])}
var staticRenderFns = []

export { render, staticRenderFns }